// CustomTable.js
import React from 'react';
import { Box, Card, CardContent, Divider, Table, TableBody, TableCell, TableRow } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { t } from '../../../constants/translationHelper';

const DetailPageCustum = ({ title, data, Icon }) => {
    const cardStyle = {
        // Add custom styles here if needed
    };

    const cardBodyStyle = {
        padding: '1rem',
    };

    const tableContainerStyle = {
        // maxHeight: '400px', 
        overflowY: 'auto',
        overflowX: 'auto',
        display: 'block',
    };

    const tableStyle = {
        minWidth: '600px',
        borderCollapse: 'collapse',
    };

    const tableCellStyle = {
        width: '200px',
        color: '#6c757d',
        border: 'none',
        borderBottom: '0',
        textTransform: 'capitalize',

    };

    const tableCellStylemiddle = {
        width: '10px',
        color: '#6c757d',
        border: 'none',
        borderBottom: '0',
    };

    const tableCellStylelast = {
        border: 'none',
        borderBottom: '0',
        textTransform: 'capitalize',

    };

    const tableRow = {
        height: '20px',
    };

    return (
        <Box id="overview">
            <Card style={cardStyle} variant="outlined">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span
                        style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "8px 8px 8px 8px",
                            fontWeight: 600,
                            fontSize: "16px",
                            color: "rgb(33, 37, 41)",
                            textTransform: "capitalize",
                        }}
                    >
                        {Icon && <Icon style={{ marginRight: "8px", fontSize: "20px", color: "#6c757d" }} />}
                        {t(title)}
                    </span>
                    <span style={{ marginRight: "12px" }}>
                        <EditIcon style={{ color: "#007bff", cursor: "pointer" }} />
                    </span>
                </div>
                <Divider />
                <CardContent style={cardBodyStyle}>
                    <Box style={tableContainerStyle}>
                        <Table style={tableStyle} size="small" aria-label={title}>
                            <TableBody>
                                {data.map((row, index) => (
                                    <TableRow key={index} style={tableRow}>
                                        <TableCell style={tableCellStyle}>
                                            <Box display="flex" alignItems="center">
                                                {row.icon && <row.icon style={{ fontSize: "20px", marginRight: "2px", marginBottom: "4px" }} />}
                                                {t(row.label)}
                                            </Box>
                                        </TableCell>

                                        <TableCell style={tableCellStylemiddle}>-</TableCell>
                                        <TableCell
                                            style={{
                                                ...tableCellStylelast,
                                                textTransform: row.label === 'Email' ? 'lowercase' : tableCellStylelast.textTransform,
                                            }}

                                        >
                                            {row.value}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Box>
                </CardContent>
            </Card>
        </Box>
    );
};

export default DetailPageCustum;




